import { render } from "./EditYourInformation.vue?vue&type=template&id=bc1f3940&ts=true"
import script from "./EditYourInformation.vue?vue&type=script&lang=ts"
export * from "./EditYourInformation.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__